import { BellRing, CheckCircle2, ShieldAlert } from "lucide-react";

import { Badge } from "@/components/ui/badge";

export const FeedbackMetadataStatusBadge = ({ status }: { status: string }) => (
  <Badge
    variant={status === "complete" ? "secondary" : "outline"}
    className="gap-1 font-normal"
  >
    {status === "complete" ? (
      <CheckCircle2 className="size-3" />
    ) : (
      <ShieldAlert className="size-3" />
    )}
    Metadata: {status.replaceAll("_", " ")}
  </Badge>
);

export const FeedbackNotificationStatusBadge = ({
  status,
}: {
  status: string;
}) => (
  <Badge
    variant={status === "sent" ? "secondary" : "outline"}
    className="gap-1 font-normal"
  >
    {status === "sent" ? (
      <CheckCircle2 className="size-3" />
    ) : (
      <BellRing className="size-3" />
    )}
    Slack: {status}
  </Badge>
);
